import Trena1 from "../util/Trena1";

import OpacityComponent from "../util/OpacityComponent";

export default function Formation(){
    return(
    <div className="w-full overflow-hidden ">
        <Trena1/>
        <OpacityComponent top="none"/>

    </div>)
}